import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import { useMemo } from 'react';
import {
  estimateTokenUsage,
  type TokenUsageEstimate,
} from './tokenUsageEstimate';

export const useTokenUsageEstimate = (
  messages: TerraUIMessage[],
): TokenUsageEstimate =>
  useMemo(() => estimateTokenUsage(messages), [messages]);
